import axios from "../../axios";

export const getAssistantInfo = async (prompt: string, threadId: string) => {
  try {
    const response = await axios.post("/assistant/get-info", { prompt, threadId });
    return {
      answer: response?.data?.result as string,
      threadId: response?.data?.threadId as string,
      languageUsed: response?.data?.langauge_used as string
    };
  } catch {
    return {
      answer: "Sorry Something went wrong!",
      threadId: "" as string,
      languageUsed: "" as string
    };
  }
};

export const getAssistantInfoForReport = async (reportId: string) => {
  try {
    const response = await axios.post("/assistant/get-assiatant-for-report", {
      report_id: reportId
    });
    return response.data.result as string;
  } catch {
    return "Error comminucating with AI";
  }
};
